<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Merchant" bc1="App" bc2="Merchant" bc3="Settings"></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn btn-gradient-danger btn-sm" @click="backTo">
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none">
        </div>
      </div>
      <div class="content-body">
        <section id="accordion-with-border" v-if="!isEmpty(merchantAccount)">
          <div class="row">
            <div class="col-sm-12">
              <div id="accordionWrapa50" role="tablist" aria-multiselectable="true">
                <div class="card collapse-icon">
                  <div class="card-header">
                    <h4 class="card-title">Merchant Settings</h4>
                  </div>
                  <div class="card-body">
                    <div class="collapse-border" id="accordionExample0">
                      <div class="card">
                        <div class="card-header collapsed" id="heading200" data-toggle="collapse" role="button"
                          data-target="#collapse200" aria-expanded="false" aria-controls="collapse200">
                          <span class="lead collapse-title">Keys</span>
                        </div>
        
                        <div id="collapse200" class="collapse" aria-labelledby="heading200" data-parent="#accordionExample0"
                          style="">
                          <div class="card-body">
                            <div class="row bg">
                              <div class="col-8">
                                <div class="form-group">
                                  <label>Client ID</label>
                                  <input class="form-control" type="text" name="client_id" v-model="client_id" disabled />
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="form-group">
                                  <label>Client Secret</label>
                                  <input class="form-control" type="text" name="client_secret" v-model="client_secret"
                                    disabled />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading210" data-toggle="collapse" role="button" data-target="#collapse210"
                          aria-expanded="false" aria-controls="collapse210">
                          <span class="lead collapse-title"> IP Config</span>
                        </div>
                        <div id="collapse210" class="collapse" aria-labelledby="heading210" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="id_1" type="checkbox" v-model="ipCheck" class="custom-control-input" />
                                    <label class="custom-control-label" for="id_1">
                                      Check IP
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-8 mt-1" v-if="ipCheck">
                                <div class="form-group">
                                  <label>Allowed Apis</label>
                                  <div v-for="(allowedIp, allowedIpIndex) in allowedIps" :key="allowedIpIndex">
                                    <div class="row">
                                      <div class="col-6">
                                        <input class="form-control mt-1" type="text" :name="'ip_' + allowedIpIndex + 1"
                                          v-model="allowedIps[allowedIpIndex]" v-validate="'required'" />
                                        <small v-show="errorBag.has('ip_' + allowedIpIndex + 1)" class="invalid-feedback">{{
                                          "*" + errorBag.first('ip_' + allowedIpIndex + 1)
                                          }}</small>
                                      </div>
                                      <div class="col-2 mt-1">
                                        <button type="button" class="btn btn-warning btn-sm"
                                          @click="removeField(allowedIpIndex)">Remove
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-5" v-if="ipCheck">
                                <button type="button" class="btn btn-gradient-primary btn-sm" @click="addIps">
                                  Add More IPs
                                </button>
                              </div>
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveData({
                                        ipCheck: ipCheck ? 1 : 0,
                                        allowedIps: JSON.stringify(allowedIps)
                                      })">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading220" data-toggle="collapse" role="button" data-target="#collapse220"
                          aria-expanded="false" aria-controls="collapse220">
                          <span class="lead collapse-title"> Merchant Type </span>
                        </div>
                        <div id="collapse220" class="collapse" aria-labelledby="heading220" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="merchant_type" type="checkbox" v-model="merchantType"
                                      class="custom-control-input" />
                                    <label class="custom-control-label" for="merchant_type">
                                      Direct
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="updateMerchantType({
                                        is_direct_merchant: merchantType ? 1 : 0,
                                      })">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading230" data-toggle="collapse" role="button" data-target="#collapse230"
                          aria-expanded="false" aria-controls="collapse230">
                          <span class="lead collapse-title"> Direct Payments </span>
                        </div>
                        <div id="collapse230" class="collapse" aria-labelledby="heading230" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="direct_pay" type="checkbox" v-model="directPay" class="custom-control-input" />
                                    <label class="custom-control-label" for="direct_pay">
                                      Allow Direct Payments
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveData({
                                        directPayment: directPay ? 1 : 0,
                                      })">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="headingBin1" data-toggle="collapse" role="button" data-target="#collapseBin1"
                             aria-expanded="false" aria-controls="collapseBin1">
                          <span class="lead collapse-title"> Bin Lookup API </span>
                        </div>
                        <div id="collapseBin1" class="collapse" aria-labelledby="headingBin1" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="bin_lookup_api" type="checkbox" v-model="accessBinLookupDetailsAPI" class="custom-control-input" />
                                    <label class="custom-control-label" for="bin_lookup_api">
                                      Allow Access To Bin Lookup API
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="headingAggApi" data-toggle="collapse" role="button" data-target="#collapseAggApi"
                             aria-expanded="false" aria-controls="collapseAggApi">
                          <span class="lead collapse-title"> Aggregator API Access </span>
                        </div>
                        <div id="collapseAggApi" class="collapse" aria-labelledby="headingAggApi" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="agg_access_api" type="checkbox" v-model="aggregatorApisAccess" class="custom-control-input" />
                                    <label class="custom-control-label" for="agg_access_api">
                                      Allow access to all apis for aggregator
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading240" data-toggle="collapse" role="button" data-target="#collapse240"
                          aria-expanded="false" aria-controls="collapse240">
                          <span class="lead collapse-title"> Direct Initiate Refund Request </span>
                        </div>
                        <div id="collapse240" class="collapse" aria-labelledby="heading240" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="direct_initaite" type="checkbox" v-model="refundDirectInitiate"
                                      class="custom-control-input" />
                                    <label class="custom-control-label" for="direct_initaite">
                                      Initiate
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="check_channel_refund" type="checkbox" v-model="checkChannelBalanceForRefunds"
                                      class="custom-control-input" />
                                    <label class="custom-control-label" for="check_channel_refund">
                                      Check Channel Balacne For Refunds
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="refundDirectProcess" type="checkbox" v-model="refundDirectProcess"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="refundDirectProcess">
                                      Refund Direct Process
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="refundRevertFeeAndVat" type="checkbox" v-model="refundRevertFeeAndVat"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="refundRevertFeeAndVat">
                                      Revert Fee/Vat to GL
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 mt-2">
                                <button type="button" class="btn btn-gradient-danger  float-right"
                                  @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading211" data-toggle="collapse" role="button" data-target="#collapse211"
                             aria-expanded="false" aria-controls="collapse211">
                          <span class="lead collapse-title"> Aggregator Permissions</span>
                        </div>
                        <div id="collapse211" class="collapse" aria-labelledby="heading211" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="auth" type="checkbox" v-model="auth"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="auth">
                                      Auth
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="paymentAuthorization" type="checkbox" v-model="paymentAuthorization"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="paymentAuthorization">
                                      Payment Authorization
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="paymentAuthorizationIncrement" type="checkbox" v-model="paymentAuthorizationIncrement"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="paymentAuthorizationIncrement">
                                      Payment Authorization Increment
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="paymentCapture" type="checkbox" v-model="paymentCapture"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="paymentCapture">
                                      Payment Capture
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="paymentReversal" type="checkbox" v-model="paymentReversal"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="paymentReversal">
                                      Payment Reversal
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="paymentRefund" type="checkbox" v-model="paymentRefund"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="paymentRefund">
                                      Payment Refund
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="paymentDetails" type="checkbox" v-model="paymentDetails"
                                           class="custom-control-input" />
                                    <label class="custom-control-label" for="paymentDetails">
                                      Payment Details
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 mt-2">
                                <button type="button" class="btn btn-gradient-danger  float-right"
                                        @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading260" data-toggle="collapse" role="button" data-target="#collapse260"
                             aria-expanded="false" aria-controls="collapse260">
                          <span class="lead collapse-title">Report Settings</span>
                        </div>
                        <div id="collapse260" class="collapse" aria-labelledby="heading260" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <label>Report Email Addresses</label>
                                  <div class="email-tags-container">
                                    <div class="email-tags-wrapper " :class="(reportEmails.length > 0) ? 'mt-1 mb-2': ''">
                                      <div v-for="(email, index) in reportEmails" :key="index" class="email-tag">
                                        <span>{{ email }}</span>
                                        <button type="button" class="btn btn-sm btn-icon" @click="removeEmail(index)">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x text-danger">
                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="input-group">
                                      <input
                                          type="email"
                                          class="form-control"
                                          placeholder="Enter email address"
                                          v-model="newEmail"
                                          @keyup.enter="addEmail"
                                      />
                                      <div class="input-group-append">
                                        <button
                                            class="btn btn-primary"
                                            type="button"
                                            @click="addEmail"
                                            :disabled="!isValidEmail(newEmail)"
                                        >
                                          Add
                                        </button>
                                      </div>
                                    </div>
                                    <small class="text-muted">Press Enter or click Add to add email addresses</small>
                                    <small v-if="emailError" class="text-danger d-block">{{ emailError }}</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row my-1">
                              <div class="col-6">
                                <div class="form-group">
                                  <label class="mb-1">Reports List</label>
                                  <div v-if="reportTypesLoading" class="text-center py-3">
                                    <div class="spinner-border text-primary" role="status">
                                      <span class="sr-only">Loading...</span>
                                    </div>
                                  </div>
                                  <div v-else-if="reportTypes.length === 0" class="text-muted py-2">
                                    No reports available
                                  </div>
                                  <div v-else class="reports-list">
                                    <div v-for="report in reportTypes" :key="report.id" class="report-item d-flex align-items-center justify-content-between ">
                                      <span class="report-name">{{ report.name }}</span>
                                      <div class="custom-control custom-switch mb-0">
                                        <input
                                          :id="'report_' + report.id"
                                          type="checkbox"
                                          class="custom-control-input"
                                          :checked="reportToggleStates[report.id]"
                                          @click.prevent="handleReportToggle(report, reportToggleStates[report.id])"
                                        />
                                        <label class="custom-control-label" :for="'report_' + report.id"></label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger float-right" @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading250" data-toggle="collapse" role="button" data-target="#collapse250"
                          aria-expanded="false" aria-controls="collapse250">
                          <span class="lead collapse-title"> Rolling Reserve Settings </span>
                     
                        </div>
                        <div id="collapse250" class="collapse" aria-labelledby="heading250" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row m-1 mt-2 border-dark  badge-glow p-3 pt-1" v-for="(rolItem,idx) in rollingReserveSettingsList">
                              <div class="col-12  justify-content-end d-flex ">
                                <feather type="x-circle" class="text-danger mb-2"  @click="rollingReserveSettingsList.splice(idx,1)" style="width: 40px;height: 40px;cursor: pointer;"></feather>
                              </div>
                              <div class="col-md-3 col-sm-12 mb-1">
                                <div class="text-center">Channels</div>
                                <div class="demo-inline-spacing d-flex justify-content-center  pl-2">
                                  <div class="text-center">
                                    <label>Select Channel</label>
                                    <select class="form-control" v-model="rollingReserveSettingsList[idx]['selectedChannel']">
                                      <option :value="null">Pick One</option>
                                      <option :key="index" v-for="(item,index) in channelData" :value="item.id">{{ item.name+'/'+item.code }}</option>
                                    </select>
        
                                  </div>
                                 
                                </div>
                              </div>
                              <div class="col-md-3 col-sm-12 mb-1">
                                <div class="text-center">Reserve</div>
                                <div class="demo-inline-spacing d-flex justify-content-center  pl-2">
                                  <div class="text-center">
                                    <label>Reserve Percentage</label>
                                    <input class="form-control" type="number" min="0" max="100" v-model="rollingReserveSettingsList[idx]['reserve']">
        
                                  </div>
                                  <span v-show="reserve<0 || reserve >100" class="text-danger">Reserve % must be greater than 0
                                    and smaller than 100</span>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-12 mb-1">
                                <div class="text-center">Duration</div>
                                <div class="demo-inline-spacing d-flex justify-content-center">
                                  <div class="text-center">
                                    <label>Days</label>
                                    <SpinBtn v-model="rollingReserveSettingsList[idx]['duration'].days" />
                                  </div>
                                  <div class="text-center">
                                    <label>Hours</label>
                                    <SpinBtn v-model="rollingReserveSettingsList[idx]['duration'].hours" :max="23" />
                                  </div>
                                  <div class="text-center">
                                    <label>Mins</label>
                                    <SpinBtn v-model="rollingReserveSettingsList[idx]['duration'].mins" :max="59" />
                                  </div>
        
                                </div>
                              </div>
                            </div>
                            <div class="row mt-5" v-if="this.rollingReserveSettingsList.length < this.channelData.length">
                              <div class="col-md-12 col-sm-12">
                                <div class="text-center">
                                  
                                  <button type="button" class="btn btn-outline-dark " @click="addRRSettings">
                                    Add More +
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 mt-2">
                                <button type="button" class="btn btn-gradient-danger  float-right"
                                  @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading270" data-toggle="collapse" role="button" data-target="#collapse270"
                             aria-expanded="false" aria-controls="collapse270">
                          <span class="lead collapse-title"> V5 Configuration </span>
                        </div>
                        <div id="collapse270" class="collapse" aria-labelledby="heading270" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="useApiV5" type="checkbox" v-model="useApiV5" class="custom-control-input" />
                                    <label class="custom-control-label" for="useApiV5">
                                      Enable V5
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading300" data-toggle="collapse" role="button" data-target="#collapse300"
                             aria-expanded="false" aria-controls="collapse300">
                          <span class="lead collapse-title"> Checkout Page Settings </span>
                        </div>
                        <div id="collapse300" class="collapse" aria-labelledby="heading300" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="showStoreName" type="checkbox" v-model="checkoutPageSettings.showStoreName" class="custom-control-input" />
                                    <label class="custom-control-label" for="showStoreName">
                                      Show Store Name
                                    </label>
                                  </div>
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="allowCustomerDetailsOnCheckoutPage" type="checkbox" v-model="checkoutPageSettings.allowCustomerDetailsOnCheckoutPage" class="custom-control-input" />
                                    <label class="custom-control-label" for="allowCustomerDetailsOnCheckoutPage">
                                      Allow Customer Details On Checkout Page
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading280" data-toggle="collapse" role="button" data-target="#collapse280"
                             aria-expanded="false" aria-controls="collapse280">
                          <span class="lead collapse-title"> Tabby Configuration </span>
                        </div>
                        <div id="collapse280" class="collapse" aria-labelledby="heading280" data-parent="#accordionExample0">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <div class="custom-control custom-switch mb-1">
                                    <input id="tabbyStatus" type="checkbox" v-model="tabbyConfiguration.status" class="custom-control-input" />
                                    <label class="custom-control-label" for="tabbyStatus">
                                      Status
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-8">
                                <div class="form-group">
                                  <label>Merchant Code</label>
                                  <input class="form-control" type="text" name="tabby_merchant_code" v-model="tabbyConfiguration.merchantCode" />
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                <button type="button" class="btn btn-gradient-danger  float-right" @click="saveDirectInitiateRefundData">
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-else>
          <div class="row">
            <!-- right content section -->
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="tab-content">

                    <div>
                      <div class="card">
                        <div class="card-header">
                          <!--                          <h2 class="card-title">Keys</h2>-->
                        </div>
                        <div class="card-body">
                          <div class="row d-flex justify-content-center">
                            <h4 v-if="!merchantSettingLoader">
                              No Data Avaliable
                            </h4>
                            <h4 v-else>
                              <div class="spinner-border text-primary"></div>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <!--/ right content section -->
          </div>
        </section>

      </div>
    </div>

    <!-- Report Confirmation Modal -->
    <div class="modal fade" :class="{ show: showReportConfirmationModal }" :style="showReportConfirmationModal ? 'display: block' : 'display: none'" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Please Confirm</h5>
            <button type="button" class="close" @click="cancelReportAction">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-if="pendingReportAction">
              Are you sure you want to {{ pendingReportAction.status ? 'enable' : 'disable' }} the status of the report "{{ pendingReportAction.reportName }}"?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelReportAction">Cancel</button>
            <button type="button" class="btn btn-primary" @click="confirmReportAction">Yes</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade" :class="{ show: showReportConfirmationModal }" :style="showReportConfirmationModal ? 'display: block' : 'display: none'"></div>
  </div>
</template>

<script>
import SpinBtn from '../../../components/common/SpinBtn.vue'

export default {
  props: ['propFilters'],
  components: { SpinBtn },
  mounted() {
    this.getMerchantSettings()
  },
  data() {
    return {
      reportEmails: [],
      newEmail: '',
      emailError: '',
      maxEmails: 10,
      reserve:0,
      duration: {
        days: 0,
        hours: 0,
        mins: 0,
      },
      merchantType: false,
      merchantSettingLoader: true,
      userRoles: [],
      accounts: [],
      cards: [],
      ipCheck: false,
      checkChannelBalanceForRefunds: false,
      allowedIps: [],
      merchantAccount: [],
      client_id: '',
      client_secret: '',
      settings: {
        Customer: '',
        UserName: '',
        Password: '',
        TransactionHint: '',
        Channel: '',
        Store: '',
        Terminal: '',
        Bypass3DS: ''
      },
      settingsState: false,
      directPay: false,
      useApiV5: false,
      accessBinLookupDetailsAPI: false,
      aggregatorApisAccess: false,
      refundDirectInitiate: false,
      refundDirectProcess: false,
      refundRevertFeeAndVat: false,
      channelData:[],
      channelLoader:false,
      rollingReserveSettingsList:[],
      auth: false,
      paymentAuthorization: false,
      paymentAuthorizationIncrement: false,
      paymentCapture: false,
      paymentReversal: false,
      paymentRefund: false,
      paymentDetails: false,
      tabbyConfiguration: {
        status: false,
        merchantCode: ''
      },
      checkoutPageSettings: {
        showStoreName: false,
        allowCustomerDetailsOnCheckoutPage: false
      },
      reportTypes: [],
      reportTypesLoading: false,
      showReportConfirmationModal: false,
      pendingReportAction: null,
      disabledReports: [],
      reportToggleStates: {},

    }
  },
  methods: {
    addEmail() {
      if (!this.newEmail.trim()) {
        this.emailError = 'Please enter an email address'
        return
      }

      if (!this.isValidEmail(this.newEmail)) {
        this.emailError = 'Please enter a valid email address'
        return
      }

      if (this.reportEmails.includes(this.newEmail.trim().toLowerCase())) {
        this.emailError = 'This email is already added'
        return
      }

      // if (this.reportEmails.length >= this.maxEmails) {
      //   this.emailError = `Maximum ${this.maxEmails} emails allowed`
      //   return
      // }

      this.reportEmails.push(this.newEmail.trim().toLowerCase())
      this.newEmail = ''
      this.emailError = ''
    },

    removeEmail(index) {
      this.reportEmails.splice(index, 1)
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },
    loadReportSettings() {
      if (typeof(this.merchantAccount.settings) != 'undefined' &&
          this.merchantAccount.settings &&
          !this.isEmpty(this.merchantAccount.settings) &&
          this.merchantAccount.settings.reportsSettings?.reportEmails) {
        try {
          this.reportEmails = this.merchantAccount.settings.reportsSettings.reportEmails || []
        } catch (e) {
          console.error('Error parsing report emails:', e)
          this.reportEmails = []
        }
      } else {
        this.reportEmails = []
      }
    },
    addRRSettings(){
      if(this.rollingReserveSettingsList.length >= this.channelData.length)
        return

      this.rollingReserveSettingsList.push({
        reserve:0,
        selectedChannel:null,
        duration: {
          days: 0,
          hours: 0,
          mins: 0,
        }
      })
    },
    saveDirectInitiateRefundData(){
      // if(this.reserve < 0 || this.reserve > 100 ){
      //   return
      // }
      let data = {
        accessBinLookupDetailsAPI: this.accessBinLookupDetailsAPI ? 1 : 0,
        aggregatorApisAccess: this.aggregatorApisAccess ? 1 : 0,
        refundDirectInitiate: this.refundDirectInitiate ? 1 : 0,
        checkChannelBalanceForRefunds: this.checkChannelBalanceForRefunds ? 1 : 0,
        refundDirectProcess: this.refundDirectProcess ? 1 : 0,
        refundRevertFeeAndVat: this.refundRevertFeeAndVat ? 1 : 0,
        useApiV5: this.useApiV5 ? 1 : 0,
        tabbyConfiguration: {
          status: this.tabbyConfiguration.status ? 1 : 0,
          merchantCode: this.tabbyConfiguration.merchantCode
        },
        checkoutPageSettings: {
          showStoreName: this.checkoutPageSettings.showStoreName ? 1 : 0,
          allowCustomerDetailsOnCheckoutPage: this.checkoutPageSettings.allowCustomerDetailsOnCheckoutPage ? 1 : 0
        }
      }

      let aggregatorPermissionsData = {
        auth: this.auth ? 1 : 0,
        paymentAuthorization: this.paymentAuthorization ? 1 : 0,
        paymentAuthorizationIncrement: this.paymentAuthorizationIncrement ? 1 : 0,
        paymentCapture: this.paymentCapture ? 1 : 0,
        paymentReversal: this.paymentReversal ? 1 : 0,
        paymentRefund: this.paymentRefund ? 1 : 0,
        paymentDetails: this.paymentDetails ? 1 : 0
      }


      let rollingReserveSettings = []

      for(let item of this.rollingReserveSettingsList){
        let durationInMinutes = (item.duration.days * 24 * 60) + (item.duration.hours * 60) + (item.duration.mins)
        rollingReserveSettings.push({
          channel_id:item.selectedChannel,
          reserve:item.reserve,
          duration:durationInMinutes
        })
      }

      this.saveData({
        settings: JSON.stringify({
         ...data,
         rollingReserveSettings,
          aggregatorPermissions:aggregatorPermissionsData,
          reportsSettings:{
            reportEmails: this.reportEmails.length > 0 ? this.reportEmails :[]
          }
        })
      })
    },
    backTo() {
      let propFilters = this.propFilters
      this.$router.push({ name: 'merchants', params: { propFilters } })
    },
    deleteSettings() {

      this.makeRequest('post', 'v1/update-merchant-settings', {
        deleteSettings: 1,
        merchantId: parseInt(this.$route.params.id)
      }).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if (!this.isEmpty(data)) {
              this.merchantAccount = data
            }

            this.allowedIps = this.merchantAccount.allowed_ips != 'undefined' ? this.merchantAccount.allowed_ips : []
            this.client_id = this.merchantAccount.client_id != 'undefined' ? this.merchantAccount.client_id : ''
            this.client_secret = this.merchantAccount.client_secret != 'undefined' ? this.merchantAccount.client_secret : ''

            this.settings = {
              Customer: '',
              UserName: '',
              Password: '',
              TransactionHint: '',
              Channel: '',
              Store: '',
              Terminal: '',
              Bypass3DS: ''
            }


            this.settingsState = false
          }
        }

      });
    },
    removeField(index) {
      this.allowedIps.splice(index, 1);
    },
    updateMerchantType(data) {
      data.merchantId = parseInt(this.$route.params.id)
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest('post', 'v1/update-merchant-settlement-type', data).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            return


          }
        }

      });
    },
    saveData(data) {
      this.$store.dispatch('exportExcelLoader', true)
      data.merchantId = parseInt(this.$route.params.id)
      // console.log(data)
      // return
      // let data = {
      //   ipCheck: this.ipCheck,
      //   allowedIps: this.allowedIps,
      // }
      this.makeRequest('post', 'v1/update-merchant-settings', data).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if (!this.isEmpty(data)) {
              this.merchantAccount = data
              this.loadReportSettings() // Reload report settings after save
            }

            this.allowedIps = this.merchantAccount.allowed_ips != 'undefined' ? this.merchantAccount.allowed_ips : []
            this.client_id = this.merchantAccount.client_id != 'undefined' ? this.merchantAccount.client_id : ''
            this.client_secret = this.merchantAccount.client_secret != 'undefined' ? this.merchantAccount.client_secret : ''
            // this.settings = this.merchantAccount.settings != 'undefined'  && this.merchantAccount.settings &&  !this.isEmpty(this.merchantAccount.settings) ? this.merchantAccount.settings : this.settings

            if (typeof (this.merchantAccount.settings) != 'undefined' && this.merchantAccount.settings != 'undefined' && this.merchantAccount.settings && !this.isEmpty(this.merchantAccount.settings)) {
              this.accessBinLookupDetailsAPI = typeof (this.merchantAccount.settings.accessBinLookupDetailsAPI) != 'undefined' ? this.merchantAccount.settings.accessBinLookupDetailsAPI : 0
              this.useApiV5 = typeof (this.merchantAccount.settings.useApiV5) != 'undefined' ? this.merchantAccount.settings.useApiV5 : 0
              this.aggregatorApisAccess = typeof (this.merchantAccount.settings.aggregatorApisAccess) != 'undefined' ? this.merchantAccount.settings.aggregatorApisAccess : 0
              this.tabbyConfiguration.status = typeof (this.merchantAccount.settings?.tabbyConfiguration?.status) != 'undefined' ? this.merchantAccount.settings.tabbyConfiguration.status : 0
              this.tabbyConfiguration.merchantCode = typeof (this.merchantAccount.settings?.tabbyConfiguration?.merchantCode) != 'undefined' ? this.merchantAccount.settings.tabbyConfiguration.merchantCode : ''
              this.checkoutPageSettings.showStoreName = typeof (this.merchantAccount.settings?.checkoutPageSettings?.showStoreName) != 'undefined' ? this.merchantAccount.settings.checkoutPageSettings.showStoreName : 0
              this.checkoutPageSettings.allowCustomerDetailsOnCheckoutPage = typeof (this.merchantAccount.settings?.checkoutPageSettings?.allowCustomerDetailsOnCheckoutPage) != 'undefined' ? this.merchantAccount.settings.checkoutPageSettings.allowCustomerDetailsOnCheckoutPage : 0
              this.refundDirectInitiate = typeof (this.merchantAccount.settings.refundDirectInitiate) != 'undefined' ? this.merchantAccount.settings.refundDirectInitiate : 0
              this.checkChannelBalanceForRefunds = typeof (this.merchantAccount.settings.checkChannelBalanceForRefunds) != 'undefined' ? this.merchantAccount.settings.checkChannelBalanceForRefunds : 0
              this.refundDirectProcess = typeof (this.merchantAccount.settings.refundDirectProcess) != 'undefined' ? this.merchantAccount.settings.refundDirectProcess : 0
              this.refundRevertFeeAndVat = typeof (this.merchantAccount.settings.refundRevertFeeAndVat) != 'undefined' ? this.merchantAccount.settings.refundRevertFeeAndVat : 0

              this.auth = typeof (this.merchantAccount.settings?.aggregatorPermissions?.auth) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.auth : 0
              this.paymentAuthorization = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorization) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorization : 0
              this.paymentAuthorizationIncrement = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorizationIncrement) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorizationIncrement : 0
              this.paymentCapture = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentCapture) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentCapture : 0
              this.paymentRefund = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentRefund) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentRefund : 0
              this.paymentReversal = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentReversal) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentReversal : 0
              this.paymentDetails = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentDetails) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentDetails : 0

              Object.keys(this.merchantAccount.settings).forEach((key) => {
                this.settings[key] = this.merchantAccount.settings[key]
              });
            }

            this.settingsState = this.merchantAccount.settings != 'undefined' && this.merchantAccount.settings && !this.isEmpty(this.merchantAccount.settings) ? true : false
          }
        }

      });
    },
    addIps() {
      this.allowedIps.push('')
    },
    getChannelData(uuid) {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", { status:'all',userId:this.$route.params.id }, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }

              }
            }
            this.channelLoader = false
          }
      );
    },
    getMerchantSettings() {
      this.makeRequest('post', 'v1/detail-merchant', { id: this.$route.params.id }, {}, false).then(callResponse => {
        this.merchantSettingLoader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if (!this.isEmpty(data.merchant_account)) {
              if (data.merchant_account[0] != 'undefined') {
                this.merchantAccount = data.merchant_account[0]
              }
            }
            this.allowedIps = this.merchantAccount.allowed_ips != 'undefined' && this.merchantAccount.allowed_ips ? this.merchantAccount.allowed_ips : []

            this.client_id = this.merchantAccount.client_id != 'undefined' ? this.merchantAccount.client_id : ''
            this.client_secret = this.merchantAccount.client_secret != 'undefined' ? this.merchantAccount.client_secret : ''
            this.ipCheck = this.merchantAccount.is_ip_check != 'undefined' ? this.merchantAccount.is_ip_check : 0
            this.merchantType = this.merchantAccount.is_direct_merchant != 'undefined' ? this.merchantAccount.is_direct_merchant : 0
            this.directPay = this.merchantAccount.direct_payment != 'undefined' ? this.merchantAccount.direct_payment : 0

            let rrSettingList = this.rollingReserveSettingsList

            if (typeof (this.merchantAccount.settings) != 'undefined' && this.merchantAccount.settings != 'undefined' && this.merchantAccount.settings && !this.isEmpty(this.merchantAccount.settings)) {

              // Load report settings
              this.loadReportSettings()

              this.accessBinLookupDetailsAPI = typeof (this.merchantAccount.settings.accessBinLookupDetailsAPI) != 'undefined' ? this.merchantAccount.settings.accessBinLookupDetailsAPI : 0
              this.useApiV5 = typeof (this.merchantAccount.settings.useApiV5) != 'undefined' ? this.merchantAccount.settings.useApiV5 : 0
              this.aggregatorApisAccess = typeof (this.merchantAccount.settings.aggregatorApisAccess) != 'undefined' ? this.merchantAccount.settings.aggregatorApisAccess : 0
              this.tabbyConfiguration.status = typeof (this.merchantAccount.settings?.tabbyConfiguration?.status) != 'undefined' ? this.merchantAccount.settings.tabbyConfiguration.status : 0
              this.tabbyConfiguration.merchantCode = typeof (this.merchantAccount.settings?.tabbyConfiguration?.merchantCode) != 'undefined' ? this.merchantAccount.settings.tabbyConfiguration.merchantCode : ''
              this.refundDirectInitiate = typeof (this.merchantAccount.settings.refundDirectInitiate) != 'undefined' ? this.merchantAccount.settings.refundDirectInitiate : 0
              this.checkChannelBalanceForRefunds = typeof (this.merchantAccount.settings.checkChannelBalanceForRefunds) != 'undefined' ? this.merchantAccount.settings.checkChannelBalanceForRefunds : 0
              this.refundDirectProcess = typeof (this.merchantAccount.settings.refundDirectProcess) != 'undefined' ? this.merchantAccount.settings.refundDirectProcess : 0
              this.refundRevertFeeAndVat = typeof (this.merchantAccount.settings.refundRevertFeeAndVat) != 'undefined' ? this.merchantAccount.settings.refundRevertFeeAndVat : 0
              this.checkoutPageSettings.showStoreName = typeof (this.merchantAccount.settings?.checkoutPageSettings?.showStoreName) != 'undefined' ? this.merchantAccount.settings.checkoutPageSettings.showStoreName : 0
              this.checkoutPageSettings.allowCustomerDetailsOnCheckoutPage = typeof (this.merchantAccount.settings?.checkoutPageSettings?.allowCustomerDetailsOnCheckoutPage) != 'undefined' ? this.merchantAccount.settings.checkoutPageSettings.allowCustomerDetailsOnCheckoutPage : 0

              this.auth = typeof (this.merchantAccount.settings?.aggregatorPermissions?.auth) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.auth : 0
              this.paymentAuthorization = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorization) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorization : 0
              this.paymentAuthorizationIncrement = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorizationIncrement) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentAuthorizationIncrement : 0
              this.paymentCapture = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentCapture) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentCapture : 0
              this.paymentRefund = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentRefund) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentRefund : 0
              this.paymentReversal = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentReversal) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentReversal : 0
              this.paymentDetails = typeof (this.merchantAccount.settings?.aggregatorPermissions?.paymentDetails) != 'undefined' ? this.merchantAccount.settings?.aggregatorPermissions?.paymentDetails : 0

              let tempRRSettings = typeof (this.merchantAccount.settings.rollingReserveSettings) != 'undefined' ? this.merchantAccount.settings?.rollingReserveSettings : this.rollingReserveSettingsList
              
              for(let item of tempRRSettings ){
                rrSettingList.push({
                  selectedChannel:item.channel_id,
                  reserve:item.reserve,
                  duration:this.convertDuration(item.duration)
                })
              }

              Object.keys(this.merchantAccount.settings).forEach((key) => {
                this.settings[key] = this.merchantAccount.settings[key]
              });
            }

            // Load disabled reports from detail-merchant API
            this.loadDisabledReports(data)

            this.settingsState = this.merchantAccount.settings != 'undefined' && this.merchantAccount.settings && !this.isEmpty(this.merchantAccount.settings) ? true : false
            this.getChannelData(data.uuid)
            this.rollingReserveSettingsList = rrSettingList
            this.getReportTypes()

          }
        }

      });

    },
    getReportTypes() {
      this.reportTypesLoading = true
      this.makeRequest('post', 'v1/get-report-types', {}, {}, false).then(callResponse => {
        this.reportTypesLoading = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code
          if (code == 200) {
            this.reportTypes = callResponse.response.data.data || []
            // Initialize toggle states based on disabled reports
            this.reportTypes.forEach(report => {
              this.$set(this.reportToggleStates, report.id, this.isReportEnabled(report.id))
            })
          }
        }
      })
    },
    loadDisabledReports(data) {
      if (data.report_types && Array.isArray(data.report_types)) {
        this.disabledReports = data.report_types.map(report => report.id)
      } else {
        this.disabledReports = []
      }
    },
    isReportEnabled(reportId) {
      // Reports are enabled by default unless they are in the disabledReports array
      return !this.disabledReports.includes(reportId)
    },
    handleReportToggle(report, currentStatus) {
      const newStatus = !currentStatus
      const action = newStatus ? 'enable' : 'disable'
      this.pendingReportAction = {
        reportId: report.id,
        status: newStatus ? 1 : 0,
        reportName: report.name
      }
      this.showReportConfirmationModal = true
    },
    confirmReportAction() {
      if (!this.pendingReportAction) return

      const { reportId, status, reportName } = this.pendingReportAction
      const action = status ? 'enable' : 'disable'

      this.makeRequest('post', 'v1/manage-report-setting', {
        merchantId: parseInt(this.$route.params.id),
        reportTypeId: reportId,
        status: status
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code
          if (code == 200) {
            // Update disabledReports array based on the action
            if (status === 0) {
              // Disable: add to disabledReports if not already there
              if (!this.disabledReports.includes(reportId)) {
                this.disabledReports.push(reportId)
              }
            } else {
              // Enable: remove from disabledReports
              const index = this.disabledReports.indexOf(reportId)
              if (index > -1) {
                this.disabledReports.splice(index, 1)
              }
            }
            // Update the toggle state to reflect the change
            this.$set(this.reportToggleStates, reportId, status === 1)
          }
        }
        this.showReportConfirmationModal = false
        this.pendingReportAction = null
      })
    },
    cancelReportAction() {
      this.showReportConfirmationModal = false
      this.pendingReportAction = null
    },
  },

}
</script>
<style scoped>
.email-tags-container {
  margin-bottom: 1rem;
}

.email-tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  //min-height: 40px;
}

.email-tag {
  display: inline-flex;
  align-items: center;
  background-color: #e9ecef;
  border: 1px solid #dee2e6;
  border-radius: 20px;
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  gap: 0.5rem;
}

.email-tag button {
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.email-tag button:hover i {
  color: #dc3545 !important;
}

.input-group {
  margin-bottom: 0.5rem;
}

.text-muted {
  font-size: 0.75rem;
}

.reports-list {
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: #f8f9fa;
}

.report-item {
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1rem;
}

.report-item:last-child {
  border-bottom: none;
}

.report-name {
  font-weight: 500;
  color: #333;
}

</style>


